import { FirebaseOptions, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeAnalytics,
  isSupported as isAnalyticsSupported,
  setAnalyticsCollectionEnabled,
  setConsent,
  type Analytics,
} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { resolveAnalyticsStream } from "../utils/analyticsStream";

const stagingConfig = {
  apiKey: "AIzaSyCZmcUm3VKdmBixKES4Gip3GeKefYk9GA8",
  authDomain: "peak-x-staging.firebaseapp.com",
  projectId: "peak-x-staging",
  storageBucket: "peak-x-staging.firebasestorage.app",
  messagingSenderId: "710805219697",
  appId: "1:710805219697:web:835bf45ac524611f6eaed0",
};

const productionConfig = {
  apiKey: "AIzaSyD_bal8834MIFxoc05zfWh7aI5K7uR_0oQ",
  authDomain: "peak-x-937b6.firebaseapp.com",
  projectId: "peak-x-937b6",
  storageBucket: "peak-x-937b6.firebasestorage.app",
  messagingSenderId: "377620642931",
  appId: "1:377620642931:web:704b27d79e552b6fe53e06",
};

const signupHosts = new Set([
  "peak-signup-flow.web.app",
  "peak-signup-flow.firebaseapp.com",
  "signup.peak.app",
]);

export const isProduction =
  process.env.REACT_APP_FORCE_PRODUCT_MODE === "true" ||
  (typeof window !== "undefined" &&
    (signupHosts.has(window.location.hostname) ||
      window.location.hostname === "peak.app" ||
      window.location.hostname === "www.peak.app"));

const firebaseConfig = isProduction ? productionConfig : stagingConfig;

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error("Firebase configuration is missing required fields.");
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app, "version2");
export const functions = getFunctions(app, "us-central1");

let analytics: Analytics | null = null;

// Production web app "Peak Signup" in peak-x-937b6.
const productionAnalytics = {
  appId: "1:377620642931:web:39d24840f89fe376e53e06",
  measurementId: "G-XRJQ95XG7M",
};
const analyticsStream = resolveAnalyticsStream(
  firebaseConfig.appId,
  isProduction ? productionAnalytics.appId : process.env.REACT_APP_GA_APP_ID_STAGING,
  isProduction
    ? productionAnalytics.measurementId
    : process.env.REACT_APP_GA_MEASUREMENT_ID_STAGING,
);
const isLocalhost =
  typeof window !== "undefined" && window.location.hostname.startsWith("localhost");

if (analyticsStream && !isLocalhost) {
  const analyticsOptions: FirebaseOptions = {
    ...firebaseConfig,
    appId: analyticsStream.appId,
    measurementId: analyticsStream.measurementId,
  };
  const analyticsApp =
    getApps().find((item) => item.name === "peak-signup-analytics") ??
    initializeApp(analyticsOptions, "peak-signup-analytics");
  setConsent({
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  isAnalyticsSupported()
    .then((supported) => {
      if (!supported) return;
      analytics = initializeAnalytics(analyticsApp, {
        config: { send_page_view: false },
      });
      setAnalyticsCollectionEnabled(analytics, false);
    })
    .catch((error) => {
      console.warn("Analytics not supported:", error);
    });
}

export function getAnalyticsInstance(): Analytics | null {
  return analytics;
}

export default app;
